export const T_AND_C_DATA = {
  en: {
    title: "Terms and Conditions",
    content: "Terms and Conditions",
  },
  ar: {
    title: "الشروط والأحكام",
    content: "الشروط والأحكام",
  },
};

export const T_AND_C_DATA_FOOTER_CARD = {
  en: {
    needHelp: "Need Help with {selectedOption}?",
    content:
      'Still unsure? Tap "Contact Us" to get in touch with our support team.',
  },
  ar: {
    needHelp: "هل تحتاج مساعدة ب{selectedOption}؟",
    content: 'لا تزال غير متأكد؟ اضغط "اتصل بنا" للتواصل مع فريق الدعم.',
  },
};

export const PRIVACY_POLICY_DATA = {
  en: {
    title: "Privacy Policy",
    content: "Privacy Policy",
  },
  ar: {
    title: "سياسة الخصوصية",
    content: "سياسة الخصوصية",
  },
};

export const ABOUT_SALAH_DATA = {
  en: {
    title: "About Salah",
    content: "About Salah",
  },
  ar: {
    title: "عن سلام",
    content: "عن سلام",
  },
};

export const TERMS_AND_CONDITIONS = {
  en: [
    {
      title: "Introduction",
      content: `By accessing or using the Ask Salah application, you agree to comply with and be bound by these Terms and Conditions. If you do not agree, you must not use the App.`,
    },
    {
      title: "About Us",
      content: `Ask Salah is a product of SmartsWay Co, operated under the SAL125 ecosystem. SmartsWay Co is registered in Kuwait, the United Kingdom, Turkey, Bosnia, and Egypt.`,
    },
    {
      title: "Definitions",
      content: [
        "“User”: Any individual or entity accessing the App.",
        "“Services”: All features, AI-powered sessions, and offerings available in the App.",
        "“Company”: SmartsWay Co.",
        "“Sessions”: AI-powered interactions provided by Ask Salah, which may be limited based on subscription level.",
      ],
    },
    {
      title: "License and Use",
      content: `Users are granted a limited, non-exclusive, non-transferable license to access and use Ask Salah. Reverse engineering, redistribution, or unauthorized commercial use is prohibited.`,
    },
    {
      title: "User Responsibilities",
      content: [
        `Users must keep login credentials confidential.`,
        `Users are responsible for all activity under their account.`,
        `Users must provide accurate information.`,
      ],
    },
    {
      title: "Content Ownership",
      content: `All intellectual property, including Ask Salah system, session structures, and branding, belongs to SmartsWay Co.`,
    },
    {
      title: "Subscriptions & Payments",
      content: [
        `In order to subscribe to Ask Salah application, the user must have an active subscription to SAL125.`,
        `The user can subscribe monthly or yearly to Ask Salah.`,
        `There are two plans: Basic (chat only) and Premium (voice interaction with Salah's voice).`,
      ],
    },
    {
      title: "Free Trial & Refund Policy",
      content: [
        `Upon registration, users are eligible for a free trial that includes three Basic plan sessions at no cost.`,
        `After the trial, continued access requires a paid subscription.`,
        `Please note, all purchases are final. Once the service has been initiated, delivered, or scheduled, no refunds will be issued under any circumstances.`,
        `Acknowledgement: By engaging with our services, you confirm that you have read, understood, and agreed to this No Refund Policy.`,
      ],
    },
    {
      title: "AI Service Disclaimer",
      content: `Ask Salah provides AI-generated sessions for guidance and growth. It is not a substitute for professional medical, legal, or financial advice.`,
    },
    {
      title: "Limitation of Liability",
      content: `The Company is not liable for indirect, incidental, or consequential damages, or reliance on AI outputs.`,
    },
    {
      title: "Security & Account Protection",
      content: [
        `Passwords must be strong (12+ characters).`,
        `Accounts may be accessed from two devices at the same time.`,
        `Identity verification is required for recovery.`,
      ],
    },
    {
      title: "Termination",
      content: `The Company may suspend or terminate accounts if users violate these terms or subscriptions expire without renewal.`,
    },
    {
      title: "Governing Law",
      content: `These Terms are governed by the laws of Kuwait and other applicable jurisdictions.`,
    },
    {
      title: "Changes to Terms",
      content: `The Company may modify these Terms. Continued use constitutes acceptance.`,
    },
  ],
  ar: [
    {
      title: " المقدمة",
      content: [
        `يُعد دخولك إلى الموقع AskSalah أو استخدامك له بمثابة إقرار منك بالموافقة والالتزام الكامل لهذه الشروط والأحكام. وفي حال عدم موافقتك، يتعين عليك الامتناع عن استخدام الموقع.`,
      ],
      isSentence: true,
    },
    {
      title: " بيانات الشركة",
      content: [
        `موقع Ask Salah هو أحد منتجات شركة SmartsWay Co ويعمل ضمن منظومة SAL125. وتعد الشركة كيانًا قانونيًا مسجلًا في كل من: دولة الكويت، المملكة المتحدة، جمهورية تركيا، جمهورية البوسنة والهرسك، وجمهورية مصر العربية، وغيرها.
`,
        
      ],
      isSentence: true,
    },

    {
      title: " التعريفات",
      content: [
        "المستخدم: كل شخص طبيعي أو اعتباري يقوم بالدخول إلى التطبيق أو استخدامه.",
        "الخدمات: كافة الميزات والجلسات والوظائف التي يوفرها التطبيق والمدعومة بالذكاء الاصطناعي.",
        "الشركة: شركة SmartsWay Co.",
        "الجلسات: التفاعلات الإلكترونية التي يتم توفيرها عبر تطبيق AskSalah، والتي قد تكون محدودة وفقًا لمستوى الاشتراك.",
      ],
    },
    {
      title: " الترخيص والاستخدام",
      content: [
        "تمنح الشركة المستخدم ترخيصًا محدودًا، غير حصري، وغير قابل للتحويل، يقتصر على الوصول إلى التطبيق واستخدامه للأغراض المشروعة فقط لا غير. ويحظر على المستخدم القيام بأي أعمال نسخ، أو إعادة توزيع، أو هندسة عكسية، أو استغلال تجاري غير مصرح به للموقع وإلا سيتعرض لمساءلة قانونية.",
      ],
      isSentence: true,
    },
    {
      title: " التزامات المستخدم",
      content: [
        "يلتزم المستخدم بالحفاظ على سرية بيانات الدخول الخاصة به.",
        "سيكون المستخدم مسؤولًا عن جميع الأنشطة التي تتم من خلال حسابه.",
        "يتعين على المستخدم تقديم بيانات صحيحة ودقيقة عند التسجيل أو استخدام التطبيق.",
      ],
    },
    {
      title: " حقوق الملكية الفكرية",
      content: [
        "تعود كافة حقوق الملكية الفكرية المتعلقة بتطبيق AskSalah، بما في ذلك النظام الداخلي وهيكلة الجلسات والعلامة التجارية، ملكًا حصريًا لشركة SmartsWay Co.",
      ],
      isSentence: true,
    },
    {
      title: " الاشتراكات والمدفوعات",
      content: [
        "يشترط للاشتراك في تطبيق Ask Salah أن يكون لدى المستخدم اشتراك ساري المفعول في منظومة SAL125",
        "يحق للمستخدم اختيار الاشتراك الشهري أو السنوي.",
        "تتوافر خطتان للاشتراك: الخطة الأساسية (خدمة الدردشة فقط) والخطة المميزة (خدمة التفاعل الصوتي مع صوت الدكتور صلاح الراشد).",
      ],
    },
    {
      title: " الفترة التجريبية وسياسة الاسترداد",
      content: [
        "يمنح المستخدم عند التسجيل فترة تجريبية مجانية تشمل ثلاث جلسات وفق الخطة الأساسية.",
        "بعد انتهاء الفترة التجريبية، يتعين على المستخدم الاشتراك المدفوع لمواصلة الاستفادة من الخدمات.",
        "تعتبر جميع المدفوعات نهائية وغير قابلة للاسترداد. وبمجرد بدء الخدمة أو تقديمها أو جدولتها يسقط حق المستخدم في استرداد أي مبالغ تحت أي ظرف.",
        "إقرار: إن استخدامك لخدمات التطبيق يعد قبولًا صريحًا بسياسة عدم الاسترداد هذه وإقرارًا منك بقراءتها وفهمها والموافقة عليها.",
      ],
    },
    {
      title: " إخلاء المسؤولية",
      content: [
        "إن الجلسات المقدمة عبر تطبيق AskSalah يتم إنشاؤها بواسطة الذكاء الاصطناعي لغرض التوجيه والدعم الشخصي. ولا تُعد هذه الجلسات بأي حال من الأحوال بديلًا عن الاستشارات الطبية أو القانونية أو المالية المتخصصة.",
      ],
      isSentence: true,
    },
    {
      title: " تحديد المسؤولية",
      content: [
        "لا تتحمل الشركة أي مسؤولية عن الأضرار غير المباشرة أو العرضية أو التبعية، أو عن أي اعتماد من قبل المستخدم على المخرجات الناتجة عن الذكاء الاصطناعي.",
      ],
      isSentence: true,
    },
    {
      title: " الأمان وحماية الحساب",
      content: [
        "يتعين على المستخدم تعيين كلمة مرور قوية لا تقل عن (12) حرفًا.",
        "يجوز الدخول إلى الحساب من خلال جهازين فقط في وقت واحد.",
        "يُشترط تقديم ما يثبت الهوية لإعادة تفعيل أو استعادة الحساب.",
      ],
    },
    {
      title: " الإنهاء",
      content: [
        "تحتفظ الشركة بالحق في تعليق أو إنهاء حساب أي مستخدم في حال مخالفته لهذه الشروط أو عند انتهاء مدة الاشتراك دون تجديد.",
      ],
      isSentence: true,
    },
    {
      title: " القانون الواجب التطبيق",
      content: [
        "تخضع هذه الشروط والأحكام لأحكام القوانين النافذة في دولة الكويت، بالإضافة إلى القوانين الأخرى المطبقة في الاختصاصات القضائية ذات الصلة.",
      ],
      isSentence: true,
    },
    {
      title: "تعديل الشروط",
      content: [
        "يجوز للشركة، وفقًا لتقديرها المطلق، تعديل هذه الشروط والأحكام. ويُعتبر استمرار المستخدم في استخدام التطبيق بعد أي تعديل بمثابة موافقة صريحة منه على هذه التعديلات",
      ],
      isSentence: true,
    },
  ],
  // arold: [
  //   {
  //     title: " المقدمة",
  //     content: [
  //       `يُعد دخولك إلى الموقع AskSalah أو استخدامك له بمثابة إقرار منك بالموافقة والالتزام الكامل لهذه`,
  //       `الشروط والأحكام. وفي حال عدم موافقتك، يتعين عليك الامتناع عن استخدام الموقع.`,
  //     ],
  //     isSentence: true,
  //   },
  //   {
  //     title: " بيانات الشركة",
  //     content: [
  //       `موقع Ask Salah هو أحد منتجات شركة SmartsWay Co ويعمل ضمن منظومة SAL125. وتعد`,
  //       `الشركة كيانًا قانونيًا مسجلًا في كل من: دولة الكويت، المملكة المتحدة، جمهورية تركيا، جمهورية`,
  //       `البوسنة والهرسك، وجمهورية مصر العربية، وغيرها.`,
  //     ],
  //     isSentence: true,
  //   },

  //   {
  //     title: " التعريفات",
  //     content: [
  //       "المستخدم: كل شخص طبيعي أو اعتباري يقوم بالدخول إلى التطبيق أو استخدامه.",
  //       "الخدمات: كافة الميزات والجلسات والوظائف التي يوفرها التطبيق والمدعومة بالذكاء الاصطناعي.",
  //       "الشركة: شركة SmartsWay Co.",
  //       "الجلسات: التفاعلات الإلكترونية التي يتم توفيرها عبر تطبيق AskSalah، والتي قد تكون محدودة",
  //       "وفقًا لمستوى الاشتراك.",
  //     ],
      
  //   },
  //   {
  //     title: " الترخيص والاستخدام",
  //     content: [
  //       "تمنح الشركة المستخدم ترخيصًا محدودًا، غير حصري، وغير قابل للتحويل، يقتصر على الوصول إلى",
  //       "التطبيق واستخدامه للأغراض المشروعة فقط لا غير. ويحظر على المستخدم القيام بأي أعمال نسخ،",
  //       "أو إعادة توزيع، أو هندسة عكسية، أو استغلال تجاري غير مصرح به للموقع وإلا سيتعرض لمساءلة",
  //       "قانونية.",
  //     ],
  //     isSentence: true,
  //   },
  //   {
  //     title: " التزامات المستخدم",
  //     content: [
  //       "يلتزم المستخدم بالحفاظ على سرية بيانات الدخول الخاصة به.",
  //       "سيكون المستخدم مسؤولًا عن جميع الأنشطة التي تتم من خلال حسابه.",
  //       "يتعين على المستخدم تقديم بيانات صحيحة ودقيقة عند التسجيل أو استخدام التطبيق.",
  //     ],
  //   },
  //   {
  //     title: " حقوق الملكية الفكرية",
  //     content: [
  //       "تعود كافة حقوق الملكية الفكرية المتعلقة بتطبيق AskSalah، بما في ذلك النظام الداخلي وهيكلة",
  //       "الجلسات والعلامة التجارية، ملكًا حصريًا لشركة SmartsWay Co.",
  //     ],
  //     isSentence: true,
  //   },
  //   {
  //     title: " الاشتراكات والمدفوعات",
  //     content: [
  //       "يشترط للاشتراك في تطبيق Ask Salah أن يكون لدى المستخدم اشتراك ساري المفعول في منظومة SAL125",
  //       "يحق للمستخدم اختيار الاشتراك الشهري أو السنوي.",
  //       "تتوافر خطتان للاشتراك: الخطة الأساسية (خدمة الدردشة فقط) والخطة المميزة (خدمة التفاعل",
  //       "الصوتي مع صوت الدكتور صلاح الراشد).",
  //     ],
  //     NoBullets: [3],
  //   },
  //   {
  //     title: " الفترة التجريبية وسياسة الاسترداد",
  //     content: [
  //       "يمنح المستخدم عند التسجيل فترة تجريبية مجانية تشمل ثلاث جلسات وفق الخطة الأساسية.",
  //       "بعد انتهاء الفترة التجريبية، يتعين على المستخدم الاشتراك المدفوع لمواصلة الاستفادة من الخدمات.",
  //       "تعتبر جميع المدفوعات نهائية وغير قابلة للاسترداد. وبمجرد بدء الخدمة أو تقديمها أو جدولتها، ",
  //       "يسقط حق المستخدم في استرداد أي مبالغ تحت أي ظرف.",
  //       "إقرار: إن استخدامك لخدمات التطبيق يعد قبولًا صريحًا بسياسة عدم الاسترداد هذه وإقرارًا منك ",
  //       "بقراءتها وفهمها والموافقة عليها.",
  //     ],
  //     NoBullets: [3, 5],
  //   },
  //   {
  //     title: " إخلاء المسؤولية",
  //     content: [
  //       "إن الجلسات المقدمة عبر تطبيق AskSalah يتم إنشاؤها بواسطة الذكاء الاصطناعي لغرض التوجيه",
  //       "والدعم الشخصي. ولا تُعد هذه الجلسات بأي حال من الأحوال بديلًا عن الاستشارات الطبية أو",
  //       "القانونية أو المالية المتخصصة.",
  //     ],
  //     isSentence: true,
  //   },
  //   {
  //     title: " تحديد المسؤولية",
  //     content: [
  //       "لا تتحمل الشركة أي مسؤولية عن الأضرار غير المباشرة أو العرضية أو التبعية، أو عن أي اعتماد من",
  //       "قبل المستخدم على المخرجات الناتجة عن الذكاء الاصطناعي.",
  //     ],
  //     isSentence: true,
  //   },
  //   {
  //     title: " الأمان وحماية الحساب",
  //     content: [
  //       "يتعين على المستخدم تعيين كلمة مرور قوية لا تقل عن (12) حرفًا.",
  //       "يجوز الدخول إلى الحساب من خلال جهازين فقط في وقت واحد.",
  //       "يُشترط تقديم ما يثبت الهوية لإعادة تفعيل أو استعادة الحساب.",
  //     ],
  //   },
  //   {
  //     title: " الإنهاء",
  //     content: [
  //       "تحتفظ الشركة بالحق في تعليق أو إنهاء حساب أي مستخدم في حال مخالفته لهذه الشروط أو عند",
  //       "انتهاء مدة الاشتراك دون تجديد.",
  //     ],
  //     isSentence: true,
  //   },
  //   {
  //     title: " القانون الواجب التطبيق",
  //     content: [
  //       "تخضع هذه الشروط والأحكام لأحكام القوانين النافذة في دولة الكويت، بالإضافة إلى القوانين الأخرى ",
  //       "المطبقة في الاختصاصات القضائية ذات الصلة.",
  //     ],
  //     isSentence: true,
  //   },
  //   {
  //     title: "تعديل الشروط",
  //     content: [
  //       "يجوز للشركة، وفقًا لتقديرها المطلق، تعديل هذه الشروط والأحكام. ويُعتبر استمرار المستخدم في",
  //       "استخدام التطبيق بعد أي تعديل بمثابة موافقة صريحة منه على هذه التعديلات",
  //     ],
  //     isSentence: true,
  //   },
  // ],
};

export const PRIVACY_POLICY = {
  en: [
    {
      title: "Introduction",
      content: `This Privacy Policy explains how Ask Salah (part of SmartsWay Co) collects, uses, and protects your information in compliance with GDPR and global privacy laws.`,
    },
    {
      title: "Information We Collect",
      content: [
        "Account details (name, email, login credentials)",
        "Subscription details (SAL125 subscription status, Ask Salah plan type: Basic or Premium)",
        "Usage data (sessions, app activity)",
        "Session content processed by AI providers",
        "Technical data (device, browser, ...).",
      ],
    },
    {
      title: "Legal Basis for Processing Data",
      subTitle: "We rely on the following legal bases to process your data:",
      content: [
        "Contractual necessity: to deliver the subscribed service.",
        "Legal compliance: to meet regulatory obligations.",
        "Legitimate interest: to improve services and ensure security.",
        "Consent: when using data for analytics or marketing (if applicable).",
      ],
    },
    {
      title: "How We Use Your Information",
      subTitle: "We use your information to:",
      content: [
        "Provide AI-powered sessions (Basic chat or Premium voice)",
        "Verify active SAL125 subscription before Ask Salah subscription",
        "Improve service and features",
        "Ensure account security",
        "Comply with legal obligations",
      ],
    },
    {
      title: "Data Sharing",
      content: [
        "Session content may be processed by third-party AI providers (e.g., OpenAI).",
        "We do not sell your personal data.",
        "Data may be shared with regulators or authorities if legally required.",
      ],
    },
    {
      title: "Security Measures",
      content: [
        "We use encryption, secure storage, and access controls.",
        "We conduct periodic reviews of security practices.",
        "Note: No system is 100% secure.",
      ],
    },
    {
      title: "User Rights",
      subTitle: "Under GDPR/CCPA, you have the right to:",
      content: [
        "Access your data",
        "Request corrections",
        "Request deletion",
        "Withdraw consent",
        "Request data portability",
        "File a complaint with the data protection authority",
      ],
    },
    {
      title: "Cookies & Tracking",
      content: `The App may use cookies and similar technologies for functionality and analytics.`,
    },
    {
      title: "Data Retention",
      content: [
        "We retain data only as long as necessary for service delivery and legal compliance.",
        "Session logs may be anonymized for improvement.",
      ],
    },
    {
      title: "International Data Transfers",
      content: `Your data may be stored or processed in different jurisdictions with appropriate safeguards such as Standard Contractual Clauses (SCCs).`,
    },
    {
      title: "Account Security",
      content: [
        "Users must create strong passwords (minimum 12 characters).",
        "Accounts are limited to use on two devices at the same time.",
        "Identity verification is required for account recovery.",
      ],
    },
    {
      title: "Governing Law",
      content: `This Policy follows the laws of Kuwait and other jurisdictions where SmartsWay Co operates.`,
    },
    {
      title: "Contact Information",
      subTitle:
        "For any queries regarding this Privacy Policy or your rights, contact us at:",
      content: [
        "Email: admin@sal125.com",
        "Telegram: https://t.me/SmartsWay125",
      ],
    },
  ],
  ar: [
    {
      title: "المقدمة",
      content: `تلتزم شركة SmartsWay Co (المالكة لتطبيق AskSalah) بحماية خصوصية مستخدميها، وتوضح هذه السياسة كيفية جمع واستخدام وحماية بياناتك الشخصية سواء للائحة العامة لحماية البيانات الأوروبية (GDPR) والقوانين العالمية ذات الصلة.`,
    },
    {
      title: "المعلومات التي نقوم بجمعها",
      content: [
        "بيانات الحساب: الاسم، البريد الإلكتروني، بيانات تسجيل الدخول.",
        "بيانات الاشتراك: حالة اشتراك SAL125، نوع خطة AskSalah (أساسية أو مميزة).",
        "بيانات الاستخدام: عدد الجلسات، نشاط التطبيق.",
        "محتوى الجلسات: البيانات التي تتم معالجتها بواسطة مزوّدي خدمات الذكاء الاصطناعي.",
        "البيانات التقنية: الجهاز، نظام التشغيل، المتصفح، ...",
      ],
    },
    {
      title: "الأساس القانوني لمعالجة البيانات",
      subTitle: "تعتمد الشركة على الأسس القانونية التالية لمعالجة بياناتك:",
      content: [
        "تنفيذ العقد: لتقديم الخدمة التي اشتركت بها.",
        "الامتثال القانوني: للوفاء بالالتزامات التنظيمية.",
        "المصلحة المشروعة: لتحسين خدماتنا وضمان أمن النظام.",
        "الموافقة: عند استخدام البيانات لأغراض تحليلية أو تسويقية (إن وجدت).",
      ],
    },
    {
      title: "كيفية استخدام البيانات",
      subTitle: "نستخدم بياناتك ل:",
      content: [
        "توفير الجلسات المدعومة بالذكاء الاصطناعي (دردشة أو صوتية).",
        "التحقق من الاشتراك النشط في SAL125.",
        "تحسين الأداء والتجربة.",
        "حماية الحسابات ومنع الاستخدام غير المصرح به.",
        "الامتثال للقوانين المعمول بها.",
      ],
    },

    {
      title: "مشاركة البيانات",
      subTitle:
        "قد تتم معالجة محتوى الجلسات من خلال مزوّدي خدمات الذكاء الاصطناعي (مثل OpenAI):",
      content: [
        "لا يتم بيع بياناتك لأي طرف ثالث.",
        "قد تتم مشاركة البيانات مع جهات تنظيمية أو قضائية عند الضرورة القانونية.",
      ],
    },
    {
      title: "حماية وأمن البيانات",
      content: [
        "استخدام التشفير والتخزين الآمن.",
        "آليات التحكم في الوصول.",
        "مراجعات دورية لإجراءات الأمان.",
        "ملاحظة: لا يوجد نظام أمني يضمن حماية مطلقة بنسبة 100%.",
      ],
    },
    {
      title: "حقوق المستخدمين",
      subTitle: "وفقًا لـ GDPR و CCPA، يحق لك:",
      content: [
        "الوصول إلى بياناتك.",
        "طلب تصحيح بياناتك.",
        "طلب حذف بياناتك.",
        "سحب موافقتك.",
        "طلب نقل بياناتك (قابلية النقل).",
        "طلب شكوى لدى السلطة المختصة بحماية البيانات.",
      ],
    },
    {
      title: "ملفات تعريف الارتباط (Cookies)",
      content: `يجوز أن يستخدم التطبيق ملفات تعريف الارتباط والتقنيات المشابهة لأغراض تشغيلية وتحليلية.`,
    },
    {
      title: "الاحتفاظ بالبيانات",
      subTitle:
        "نحتفظ ببياناتك فقط طوال المدة اللازمة لتقديم الخدمة أو للامتثال للقانون.",
      content: [
        "نحتفظ ببياناتك فقط طوال المدة اللازمة لتقديم الخدمة أو للامتثال للقانون.",
        "قد يتم إخفاء هوية بيانات الجلسات واستخدامها لأغراض التحسين.",
      ],
    },
    {
      title: "نقل البيانات دوليًا",
      content: `قد يتم تخزين بياناتك أو معالجتها في بلدان خارج نطاق إقامتك، مع ضمان وجود تدابير حماية مناسبة مثل بنود تعاقدية قياسية (Standard Contractual Clauses).`,
    },
    {
      title: "أمن الحساب",
      content: [
        "يلتزم المستخدم بإنشاء كلمة مرور قوية (12 حرفًا على الأقل).",
        "الحساب متاح للاستخدام على جهازين فقط في الوقت ذاته.",
        "يشترط التحقق من الهوية لاستعادة الحساب.",
      ],
    },
    {
      title: "القانون الواجب التطبيق",
      content: `تخضع هذه السياسة للقوانين المعمول بها في دولة الكويت، بالإضافة إلى القوانين السارية في الولايات القضائية التي تعمل بها شركة SmartsWay Co.`,
    },
    {
      title: "بيانات التواصل",
      subTitle:
        "للاستفسارات المتعلقة بسياسة الخصوصية أو حقوقك، يمكن التواصل عبر:",
      content: [
        "البريد الإلكتروني: admin@sal125.com",
        "قناة Telegram: https://t.me/SmartsWay125",
      ],
    },
  ],
};
